import { createContext, useContext } from "react";

import type { DataSubmissionRepository } from "@/repositories/data-submission-repository.ts";
import type { NewsRepository } from "@/repositories/news-repository.ts";
import type { SessionRepository } from "@/repositories/session-repository.ts";
import type { SiteSettingsRepository } from "@/repositories/site-settings-repository.ts";
import type { UserRepository } from "@/repositories/user-repository.ts";
import type AuthService from "@/services/auth-service.ts";
import type SessionService from "@/services/session-service.ts";

export type Repos = {
    sessionRepo: SessionRepository;
    userRepo: UserRepository;
    newsRepo: NewsRepository;
    dataSubmissionRepo: DataSubmissionRepository;
    authService: AuthService;
    sessionService: SessionService;
    settingsRepo: SiteSettingsRepository;
};

export const ReposContext = createContext<Repos | null>(null);

// Full context hook (optional)
export function useRepos() {
    const ctx = useContext(ReposContext);
    if (!ctx) throw new Error("useRepos must be used inside ReposProvider");
    return ctx;
}
